// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
    overflow-x: hidden;
    width: 100%;
    box-sizing: border-box;
}



.uk-button{
    margin: 0;
    border: none;
    overflow: visible;
    font: inherit;
    color: inherit;
    text-transform: none;
    -webkit-appearance: none;
    display: inline-block;
    box-sizing: border-box;
    padding: 0;
    vertical-align: middle;
    font-size: 16px!important;
    text-align: center;
    text-decoration: none;
    height: 45px;
}

.uk-button-primary {
    background-color: #22526c;
    color: #ffffff;
    padding: 0px 0px;
}

.uk-button-secondary {
    background-color: #22526c;
    color: #ffffff;
    border: solid #22526c 2px;
    margin: none!important;
    line-height: 16px!important;
    box-sizing: border-box;
    height: 48px;
}

.send-quote-button{
    border-top-left-radius: 0px!important;
    border-bottom-left-radius: 0px!important;
}

.uk-button-secondary:hover {
    background-color: #14303f;
}

.cat-buttons{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.cat-buttons .uk-button{
    width: calc(25% - 8px);
    box-sizing: border-box;
}

.uk-button-primary:hover {
    background-color: #14303f;
}

.uk-active {
    background-color: #14303f!important;
}

.uk-input {
    height: 48px;
}

.uk-select {
    height: 48px!important;
}

input {
    width: 100%!important;
    -moz-appearance: textfield;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.uk-form-label{
    font-size: 16px!important;
    margin-bottom: 16px!important;
}

.uk-button:disabled {
    background-color: lightgrey;
    color: rgb(119, 119, 119);
    cursor: not-allowed;
    border: solid lightgrey 2px;
}

.uk-button:disabled:hover {
    background-color: lightgrey;
}

.uk-section-primary {
    --uk-inverse: light;
    background: #22526c;
}

.subcat-buttons {
    display: flex; 
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}

.subcat-buttons .uk-button {
    flex: 1 1; 
}

.subcat-buttons .uk-button {
    min-height: 40px; 
}

.sticky-banner{
    width: 100%;
    display: flex;
    padding: 16px;
    justify-content: space-between;
    background-color: #6294AA;
    color: #ffffff;
    box-sizing: border-box;
    align-items: center;
    height: 70px;
    font-weight: 500;
    font-family: "Open Sans", sans-serif;
}

.mobile-title{
    font-size: 20px;
}

.menu-icon{
    width: 50px;
}

.mobile-logo{
    width: 50px;
    padding: 8px;
    box-sizing: border-box;
}


.email-input{
    border-top-left-radius: 4px!important;
    border-bottom-left-radius: 4px!important;
    height: 60px;
}

.left-right-cont{
    display: flex;
    flex-direction: row;
    align-items: space-around;
}

.left-cont{
    width: 100%;
    padding-right: 15px;
    box-sizing: border-box;
}

.right-cont{
    width: 50%;
    padding-left: 15px;
    box-sizing: border-box;
    position: sticky;
    top: 0;
    max-height: fit-content;
    height: 100vh;
}

.send-button{
    width: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    height: 50px;
    background-color: #F6F7F9;
    transition: all 0.3s ease;
    cursor: pointer;
}

.send-button:hover{
    background-color: #d3e0fa;
}

.save-button{
    padding: 10px 20px;
    color: #F6F7F9;
    border: none;
    border-radius: 6px;
    transition: background-color 0.3s ease;
    font-size: 16px;
    transition: all 0.3s ease;
    cursor: pointer;
}

.save-button:hover{
    color: #d3e0fa;
}

.custom-prompt {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.prompt-content {
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    width: 300px;
    text-align: center;
}

.prompt-input {
    width: 100%;
    padding: 10px;
    margin: 10px 0;
    background-color: #F6F7F9;
    border: none;
    font-size: 16px;
    box-sizing: border-box;
    transition: all 0.3s ease;
}

.prompt-input:focus{
    outline: none;
    background-color: #d3e0fa;
}

.prompt-input:hover{
    background-color: #d3e0fa;
}

.button-group {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}

.save-btn, .cancel-btn {
    padding: 8px 15px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s ease;
}

.save-btn {
    background: #6294AA;
    color: white;
}

.save-btn:hover {
    background: #4d8299;
}

.cancel-btn {
    background: #dddddd;
    color: #666666;
}

.cancel-btn:hover {
    background: #c7c7c7;
}

.desktop{
    display: flex;
}

.title-logo{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.QR-container{
    border: solid #6395ab 2px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    margin-top: 20px;
}

.QR-title{
    font-size: 18px;
    font-weight: 700;
    color: #2e2e2e;
    text-align: center;
}

.QR-code{
    max-width: 200px;
}

.QR-content{
    font-size: 15px;
    color: #2e2e2e;
}


@media (max-width: 1200px) {
    .left-right-cont{
        flex-direction: column;
    }

    .right-cont{
        width: 100%;
    }

    .uk-button {
        font-size: 12px; 
        line-height: 40px; 
    }

    .uk-input,
    .send-quote-button,
    .uk-select {
        height: 40px!important; 
    }

    .uk-form-label {
        font-size: 18px; 
    }

    .uk-button-primary {
        height: 40px;
        line-height: normal;
    }

    .title-logo{
        flex-direction: column-reverse;
    }
}

@media (max-width: 1000px) {
    .uvalue-flex {
        flex-direction: column !important;
    }
    .app-vid img {
        height: auto !important;
        max-height: 500px;
        width: 100% !important;
    }
    .right-cont{
        padding-left: 0px;;
    }
    .left-cont{
        padding-right: 0px;
    }
}

@media (max-width: 500px) {
    .desktop{
        display: none;
    }

    .uk-button {
        font-size: 16px!important;
        padding: 0px 10px;
    }

    .uk-button-secondary{
        border: solid #ffffff 2px;
    }
    .cat-buttons .uk-button{
        width: calc(50% - 5px);
    }

    .mobile-cat-name{
        margin-top: 2px;
    }

    .uk-margin-large-top{
        margin-top: 10px!important;
    }

    .uk-margin-medium-top{
        margin-top: 16px!important;
    }
    .uk-margin-small-bottom{
        margin-bottom: 16px!important;
    }
    
    .uk-form-label{
        font-size: 20px!important;
        margin-bottom: 16px!important;
    }

    .uk-margin-medium-bottom{
        margin-bottom: 16px!important;
    }

    .ui-container{
        margin-bottom: 0px!important;
    }
}

@media (max-width:330px) {

    .mobile-title{
        font-size: 18px;
    }

    .menu-icon{
        width: 40px;
    }

    .mobile-logo{
        width: 40px;
        padding: 8px;
    }

    .uk-button{
        font-size: 15px!important;
    }
}`, "",{"version":3,"sources":["webpack://./src/UvalueCalculator.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,sBAAsB;AAC1B;;;;AAIA;IACI,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,wBAAwB;IACxB,qBAAqB;IACrB,sBAAsB;IACtB,UAAU;IACV,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,2BAA2B;IAC3B,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,cAAc;IACd,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;;AAGA;IACI,qCAAqC;IACrC,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IAEtB,gBAAgB;IAChB,MAAM;IACN,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;;AAGA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,iCAAiC;IACrC;IACA;QACI,uBAAuB;QACvB,iBAAiB;QACjB,sBAAsB;IAC1B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;IAC7B;IACA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;IACA;QACI,6BAA6B;IACjC;;IAEA;QACI,yBAAyB;QACzB,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["html, body {\n    overflow-x: hidden;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n\n\n.uk-button{\n    margin: 0;\n    border: none;\n    overflow: visible;\n    font: inherit;\n    color: inherit;\n    text-transform: none;\n    -webkit-appearance: none;\n    display: inline-block;\n    box-sizing: border-box;\n    padding: 0;\n    vertical-align: middle;\n    font-size: 16px!important;\n    text-align: center;\n    text-decoration: none;\n    height: 45px;\n}\n\n.uk-button-primary {\n    background-color: #22526c;\n    color: #ffffff;\n    padding: 0px 0px;\n}\n\n.uk-button-secondary {\n    background-color: #22526c;\n    color: #ffffff;\n    border: solid #22526c 2px;\n    margin: none!important;\n    line-height: 16px!important;\n    box-sizing: border-box;\n    height: 48px;\n}\n\n.send-quote-button{\n    border-top-left-radius: 0px!important;\n    border-bottom-left-radius: 0px!important;\n}\n\n.uk-button-secondary:hover {\n    background-color: #14303f;\n}\n\n.cat-buttons{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.cat-buttons .uk-button{\n    width: calc(25% - 8px);\n    box-sizing: border-box;\n}\n\n.uk-button-primary:hover {\n    background-color: #14303f;\n}\n\n.uk-active {\n    background-color: #14303f!important;\n}\n\n.uk-input {\n    height: 48px;\n}\n\n.uk-select {\n    height: 48px!important;\n}\n\ninput {\n    width: 100%!important;\n    -moz-appearance: textfield;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.uk-form-label{\n    font-size: 16px!important;\n    margin-bottom: 16px!important;\n}\n\n.uk-button:disabled {\n    background-color: lightgrey;\n    color: rgb(119, 119, 119);\n    cursor: not-allowed;\n    border: solid lightgrey 2px;\n}\n\n.uk-button:disabled:hover {\n    background-color: lightgrey;\n}\n\n.uk-section-primary {\n    --uk-inverse: light;\n    background: #22526c;\n}\n\n.subcat-buttons {\n    display: flex; \n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n}\n\n.subcat-buttons .uk-button {\n    flex: 1; \n}\n\n.subcat-buttons .uk-button {\n    min-height: 40px; \n}\n\n.sticky-banner{\n    width: 100%;\n    display: flex;\n    padding: 16px;\n    justify-content: space-between;\n    background-color: #6294AA;\n    color: #ffffff;\n    box-sizing: border-box;\n    align-items: center;\n    height: 70px;\n    font-weight: 500;\n    font-family: \"Open Sans\", sans-serif;\n}\n\n.mobile-title{\n    font-size: 20px;\n}\n\n.menu-icon{\n    width: 50px;\n}\n\n.mobile-logo{\n    width: 50px;\n    padding: 8px;\n    box-sizing: border-box;\n}\n\n\n.email-input{\n    border-top-left-radius: 4px!important;\n    border-bottom-left-radius: 4px!important;\n    height: 60px;\n}\n\n.left-right-cont{\n    display: flex;\n    flex-direction: row;\n    align-items: space-around;\n}\n\n.left-cont{\n    width: 100%;\n    padding-right: 15px;\n    box-sizing: border-box;\n}\n\n.right-cont{\n    width: 50%;\n    padding-left: 15px;\n    box-sizing: border-box;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    max-height: fit-content;\n    height: 100vh;\n}\n\n.send-button{\n    width: 20%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    height: 50px;\n    background-color: #F6F7F9;\n    transition: all 0.3s ease;\n    cursor: pointer;\n}\n\n.send-button:hover{\n    background-color: #d3e0fa;\n}\n\n.save-button{\n    padding: 10px 20px;\n    color: #F6F7F9;\n    border: none;\n    border-radius: 6px;\n    transition: background-color 0.3s ease;\n    font-size: 16px;\n    transition: all 0.3s ease;\n    cursor: pointer;\n}\n\n.save-button:hover{\n    color: #d3e0fa;\n}\n\n.custom-prompt {\n    background-color: rgba(0, 0, 0, 0.5);\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.prompt-content {\n    background: white;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n    width: 300px;\n    text-align: center;\n}\n\n.prompt-input {\n    width: 100%;\n    padding: 10px;\n    margin: 10px 0;\n    background-color: #F6F7F9;\n    border: none;\n    font-size: 16px;\n    box-sizing: border-box;\n    transition: all 0.3s ease;\n}\n\n.prompt-input:focus{\n    outline: none;\n    background-color: #d3e0fa;\n}\n\n.prompt-input:hover{\n    background-color: #d3e0fa;\n}\n\n.button-group {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 10px;\n}\n\n.save-btn, .cancel-btn {\n    padding: 8px 15px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: all 0.3s ease;\n}\n\n.save-btn {\n    background: #6294AA;\n    color: white;\n}\n\n.save-btn:hover {\n    background: #4d8299;\n}\n\n.cancel-btn {\n    background: #dddddd;\n    color: #666666;\n}\n\n.cancel-btn:hover {\n    background: #c7c7c7;\n}\n\n.desktop{\n    display: flex;\n}\n\n.title-logo{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.QR-container{\n    border: solid #6395ab 2px;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n    margin-top: 20px;\n}\n\n.QR-title{\n    font-size: 18px;\n    font-weight: 700;\n    color: #2e2e2e;\n    text-align: center;\n}\n\n.QR-code{\n    max-width: 200px;\n}\n\n.QR-content{\n    font-size: 15px;\n    color: #2e2e2e;\n}\n\n\n@media (max-width: 1200px) {\n    .left-right-cont{\n        flex-direction: column;\n    }\n\n    .right-cont{\n        width: 100%;\n    }\n\n    .uk-button {\n        font-size: 12px; \n        line-height: 40px; \n    }\n\n    .uk-input,\n    .send-quote-button,\n    .uk-select {\n        height: 40px!important; \n    }\n\n    .uk-form-label {\n        font-size: 18px; \n    }\n\n    .uk-button-primary {\n        height: 40px;\n        line-height: normal;\n    }\n\n    .title-logo{\n        flex-direction: column-reverse;\n    }\n}\n\n@media (max-width: 1000px) {\n    .uvalue-flex {\n        flex-direction: column !important;\n    }\n    .app-vid img {\n        height: auto !important;\n        max-height: 500px;\n        width: 100% !important;\n    }\n    .right-cont{\n        padding-left: 0px;;\n    }\n    .left-cont{\n        padding-right: 0px;\n    }\n}\n\n@media (max-width: 500px) {\n    .desktop{\n        display: none;\n    }\n\n    .uk-button {\n        font-size: 16px!important;\n        padding: 0px 10px;\n    }\n\n    .uk-button-secondary{\n        border: solid #ffffff 2px;\n    }\n    .cat-buttons .uk-button{\n        width: calc(50% - 5px);\n    }\n\n    .mobile-cat-name{\n        margin-top: 2px;\n    }\n\n    .uk-margin-large-top{\n        margin-top: 10px!important;\n    }\n\n    .uk-margin-medium-top{\n        margin-top: 16px!important;\n    }\n    .uk-margin-small-bottom{\n        margin-bottom: 16px!important;\n    }\n    \n    .uk-form-label{\n        font-size: 20px!important;\n        margin-bottom: 16px!important;\n    }\n\n    .uk-margin-medium-bottom{\n        margin-bottom: 16px!important;\n    }\n\n    .ui-container{\n        margin-bottom: 0px!important;\n    }\n}\n\n@media (max-width:330px) {\n\n    .mobile-title{\n        font-size: 18px;\n    }\n\n    .menu-icon{\n        width: 40px;\n    }\n\n    .mobile-logo{\n        width: 40px;\n        padding: 8px;\n    }\n\n    .uk-button{\n        font-size: 15px!important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
